/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FormSignatureCreateDto } from '../../models/form-signature-create-dto';
import { FormSignatureCreateResponseDto } from '../../models/form-signature-create-response-dto';

export interface Create$Params {
  formId: string;
  body: FormSignatureCreateDto;
}

export function create(
  http: HttpClient,
  rootUrl: string,
  params: Create$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<FormSignatureCreateResponseDto>> {
  const rb = new RequestBuilder(rootUrl, create.PATH, 'post');
  if (params) {
    rb.path('formId', params.formId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FormSignatureCreateResponseDto>;
    })
  );
}

create.PATH = '/forms/{formId}/signatures';
